import React from 'react';

function ShortcutsPanel({
  onOpenSugarAdd,
  onOpenInsulinAdd,
  onOpenFoodIntake,
  onOpenTaskList,
  onOpenBaseAdd,
  onOpenDailyEventsAdd,
}) {
  const shortcuts = [
    { id: 'blood', icon: '🩸', label: 'Blood sugar', action: () => onOpenSugarAdd?.() },
    { id: 'insulin', icon: '💉', label: 'Insulin', action: () => onOpenInsulinAdd?.() },
    { id: 'home', icon: '🏠', label: 'Home', action: () => onOpenBaseAdd?.() },
    { id: 'daily-events', icon: '🗒️', label: 'Daily events', action: () => onOpenDailyEventsAdd?.() },
    { id: 'food', icon: '🍽️', label: 'Food intake', action: () => onOpenFoodIntake?.() },
    { id: 'tasks', icon: '✅', label: 'Tasks', action: () => onOpenTaskList?.() },
  ];

  return (
    <div
      style={{
        background: 'transparent',
        borderRadius: 16,
        padding: 24,
        boxShadow: 'none',
        minWidth: 0,
        width: '520px',
        maxWidth: '92vw',
        minHeight: 0,
        height: '320px',
        maxHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: 14,
          width: '100%',
          maxWidth: 360,
        }}
      >
        {shortcuts.map((s) => (
          <button
            key={s.id}
            type="button"
            aria-label={s.label}
            title={s.label}
            onClick={() => {
              if (typeof s.action === 'function') {
                s.action();
                return;
              }

              // Keeping other shortcuts as UI-only for now.
            }}
            style={{
              appearance: 'none',
              WebkitAppearance: 'none',
              border: '1px solid rgba(0,0,0,0.08)',
              background: 'rgba(0,0,0,0.02)',
              borderRadius: 18,
              width: '100%',
              aspectRatio: '1 / 1',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '2rem',
              lineHeight: 1,
              boxShadow: '0 1px 10px rgba(0,0,0,0.06)',
              userSelect: 'none',
            }}
          >
            {s.icon}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ShortcutsPanel;
